import splitFileName from './splitFileName'
/**
 * @param {string} fileName
 */
const baseNameFromFile = fileName => {
  return splitFileName(fileName)?.[0] || ''
}

export default baseNameFromFile
